import { css } from "@compiled/react";
import PropTypes from "prop-types";

import { wacToken } from "@/libraries/design/foundations";

type UniformHortizontalDividerProps = {
    lineStyle?: "solid" | "dotted";
};

const dividerStyle = css({
    width: "100%",
    border: "none",
    margin: 0
});

const HorizontalDivider: React.FC<UniformHortizontalDividerProps> = ({
    lineStyle = "solid"
}) => {
    return (
        <hr
            css={dividerStyle}
            role="presentation"
            style={{
                borderBlockStart: `1px ${lineStyle} ${wacToken(
                    "color.neutral.light400"
                )}`
            }}
        />
    );
};

HorizontalDivider.propTypes = {
    lineStyle: PropTypes.string
};

export default HorizontalDivider;
